import { render, staticRenderFns } from "./ShopCates.vue?vue&type=template&id=b16ffc5e&scoped=true"
import script from "./ShopCates.vue?vue&type=script&lang=js"
export * from "./ShopCates.vue?vue&type=script&lang=js"
import style0 from "./ShopCates.vue?vue&type=style&index=0&id=b16ffc5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16ffc5e",
  null
  
)

export default component.exports